import { ComponentProps } from 'react';

type ButtonProps = Readonly<
  {
    content: string;
    childLeft?: React.ReactNode;
    childRight?: React.ReactNode;
  } & ComponentProps<'button'>
>;

function Button({ content, childLeft, childRight, ...rest }: ButtonProps) {
  return (
    <button type="button" {...rest}>
      {childLeft}
      <Button.Inner content={content} />
      {childRight}
    </button>
  );
}

function Inner({ content }: { content: string | React.ReactNode }) {
  return (
    <span className="inner">
      <span className="text">{content}</span>
      <span className="hover">{content}</span>
    </span>
  );
}

Button.Inner = Inner;
export default Button;
